var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.005,
    height: 24.005,
    viewBox: "0 0 24.005 24.005",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .error_a {\n                fill: #ff4e4e;\n            }\n\n            .error_b {\n                fill: none !important;\n                opacity: 0.87;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "error_a",
    d: "M11.64,15.48h1.92V17.4H11.64Zm0-7.68h1.92v5.76H11.64ZM12.59,3a9.6,9.6,0,1,0,9.61,9.6A9.6,9.6,0,0,0,12.59,3Zm.01,17.28a7.68,7.68,0,1,1,7.68-7.68A7.678,7.678,0,0,1,12.6,20.28Z",
    transform: "translate(-0.602 -0.602)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "error_b",
    d: "M0,0H24V24H0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_error.4c19f6a36abdff5d0e8ce0ac114bd855.svg";